/**
 * Guards against a core module being imported more than once.
 * @param parentModule The already-loaded parent module instance, if any.
 * @param moduleName Name used in the thrown error message.
 */
export function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(
      `${moduleName} has already been loaded. Import Core modules in the AppModule only.`,
    );
  }
}
